import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { LockAuditLog, LogFormTypes } from './types';
import { PermissionEnum } from '../../base-types';
import SidePanelLoader from '../side-panel/loader';
import PermissionDenied from '../permission-denied/permission-denied';
import LogForm from './components/log-form';
import SidePanel from '../side-panel/side-panel';
import ButtonPseudo from '../button/button-pseudo';
import { SidePanelType } from '../side-panel/types';

export default function SecurityLogForm({
  clearLogPanelState,
  onClose,
  getLogItem,
  getLockItemUser,
  activePermissions,
  logItem,
  logItemUser,
  isLoading,
  isFetching,
  wuthoutCustomer,
}: LogFormTypes) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [organizations, setOrganizations] = useState<
    | {
        id: string;
        user: { id: string; profile: { firstName: string; lastName: string } };
      }[]
    | undefined
  >(undefined);

  const { logId } = useParams();

  const { control, reset } = useForm<LockAuditLog>();

  const handleClose = () => {
    clearLogPanelState();

    setPanelIsOpen(false);
    reset({});
    clearLogPanelState();
    setOrganizations(undefined);

    setTimeout(() => {
      onClose();
    }, 100);
  };

  useEffect(() => {
    if (logId && activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
      getLogItem(logId);
    }
  }, [logId, activePermissions]);

  useEffect(() => {
    if (logItem) {
      reset({
        result: logItem.result,
        createdAt: logItem.createdAt || '',
        action: logItem.action,
        userId: logItem.userId,
        ipSource: logItem?.ipSource,
      });

      if (logItem.userId && getLockItemUser) {
        getLockItemUser(logItem.userId);
      }
    }
  }, [logItem]);

  useEffect(() => {
    if (logItemUser) {
      setOrganizations([
        {
          id: logItemUser.id,
          user: {
            id: logItemUser.id,
            profile: {
              firstName: logItemUser?.profile?.firstName || '',
              lastName: logItemUser?.profile?.lastName || '',
            },
          },
        },
      ]);
    }
  }, [logItemUser]);

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  let content;

  if (activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    if (isLoading || isFetching) {
      content = <SidePanelLoader />;
    } else {
      content = (
        <LogForm
          control={control}
          organizations={organizations?.map((item) => ({
            name: item?.user?.profile?.firstName
              ? `${item?.user?.profile?.firstName} ${item?.user?.profile?.lastName}`
              : '-',
            value: item.user.id,
          }))}
          userId={logItem?.userId}
          role={
            logItemUser?.serviceRole?.length
              ? logItemUser?.serviceRole[0]
              : undefined
          }
          wuthoutCustomer={wuthoutCustomer}
        />
      );
    }
  } else {
    content = <PermissionDenied />;
  }

  return (
    <SidePanel
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title="Audit Log Details"
      type={SidePanelType.AML}
      sidepanelExpandedKey="lock-audit-log-panel"
      footer={<ButtonPseudo text="Cancel" onClick={handleClose} bold />}
    >
      {content}
    </SidePanel>
  );
}
